import { OTLPMetricExporter } from '@opentelemetry/exporter-metrics-otlp-http';
import { Resource } from '@opentelemetry/resources';
import { MeterProvider, AggregationTemporality, ConsoleMetricExporter } from '@opentelemetry/sdk-metrics';
import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions';
import { InstantaneousMetricReader } from '../../export/InstantaneousMetricReader.mjs';

const OTEL_ENDPOINTS = {
  production: 'https://otlp-http-production.shopifysvc.com/v1/metrics',
  staging: 'https://otlp-http-staging.shopifysvc.com/v1/metrics',
  local: 'http://localhost:4318/v1/metrics'
};
class DefaultMeterProvider extends MeterProvider {
  constructor({
    serviceName,
    env,
    throttleLimit,
    useXhr,
    dev
  }) {
    super({
      resource: new Resource({
        [SemanticResourceAttributes.SERVICE_NAME]: serviceName
      })
    });
    const opts = {
      url: OTEL_ENDPOINTS[env] || env,
      temporalityPreference: AggregationTemporality.DELTA
    };
    if (useXhr) {
      opts.headers = {};
    }
    const exporter = new OTLPMetricExporter(opts);
    this.addMetricReader(new InstantaneousMetricReader({
      exporter,
      throttleLimit
    }));

    // Add a console exporter to see what we are sending in dev environments
    if (dev) {
      this.addMetricReader(new InstantaneousMetricReader({
        exporter: new ConsoleMetricExporter(),
        throttleLimit
      }));
    }
  }
}

export { DefaultMeterProvider };
